import { render } from "./IdDuplication.vue?vue&type=template&id=76b8beb9&scoped=true&ts=true"
import script from "./IdDuplication.vue?vue&type=script&lang=ts"
export * from "./IdDuplication.vue?vue&type=script&lang=ts"

import "./IdDuplication.vue?vue&type=style&index=0&id=76b8beb9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b8beb9"],['__file',"src/components/kyc/IdDuplication.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76b8beb9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76b8beb9', __exports__)) {
    api.reload('76b8beb9', __exports__)
  }
  
  module.hot.accept("./IdDuplication.vue?vue&type=template&id=76b8beb9&scoped=true&ts=true", () => {
    api.rerender('76b8beb9', render)
  })

}


export default __exports__